import { AuthorI } from './author';
import { LawSubBranchDTO } from './lawBranch';
import { PublicationI } from './publication';
import { WorkspaceI } from './workspace';

export interface DocumentI {
    id: number;
    evidensseId: string;
    title: string;
    synopsis: string;
    version: number;
    reference: string;
    partner: string;
    authors: AuthorI[];
    status: PublicationStatusE;
    typeCode: string;
    hits: string;
    // dates
    publication: string;
    applicability: string;
    documentDate: string;
    endApplicability: string;
    resume: string;
    // This is for carousel only, and was done under time pressure.
    // Backend endpoint returns document views grouped by workspaces, but there are type of carousel that require workspace for grouping
    // that is having list of documents as input, so as a quick solution I decided to fill documents with workspaces data after
    // fetching data from backend. In the best scenario, there should be other type of carousel that will accept groups of documents,
    // instead of simple documents list
    additionalWorkspaces: WorkspaceI[];
}

export enum PublicationStatusE {
    UP_TO_DATE = 'UP_TO_DATE',
    MODIFIED = 'MODIFIED',
    UNAVAILABLE = 'UNAVAILABLE',
    FORBIDDEN = 'FORBIDDEN'
}
export interface DocumentTypeI {
    id: string;
    label: string;
    code: string;
    showed: boolean;
    orderNumber: number;
    legalWeight: string;
    documentFieldTypes: DocumentFieldTypeI[];
}

export interface DocumentFieldTypeI {
    id: number;
    fieldTypeName: string;
    documentTypeId: string;
    displayable: boolean;
    searchable: boolean;
}

export interface DocumentPaginationI {
    number: number;
    size: number;
    documentSort: DocumentSort;
}

export interface DocumentFilterI {
    keys: string;
    suggestReference: string;
    attributes: {
        endDateOfApplicability: boolean[];
        findInAccessibleOnly: boolean[];
    };
    pagination: {
        page: number;
        size: number;
        sort: string;
    };
}

enum DocumentSort {
    RELEVANCE = 'RELEVANCE',
    APPLICABILITY_DATE = 'APPLICABILITY_DATE',
    DOCUMENT_DATE = 'DOCUMENT_DATE'
}

export interface DocumentArticleNodeI {
    num: string;
    articleId: string;
    title?: string;
    children?: DocumentArticleNodeI[];
}

export interface DocumentSaveDialogDataI {
    id: number;
    title: string;
    reference?: string;
    type: string;
    mainWorkspaceName?: string;
    lawSubBranches?: LawSubBranchDTO[];
    version?: number;
}
